"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textinput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const errorMessage_1 = __importDefault(require("../errorMessage/errorMessage"));
const textinput_style_1 = __importDefault(require("./textinput.style"));
const status_1 = require("../constants/status");
const textinput_suffix_1 = __importDefault(require("./textinput.suffix"));
class Textinput extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            hasFocus: false,
            focusCounter: 0
        };
        this.handleFocus = e => {
            window.clearTimeout(this.timer);
            this.setState({
                hasFocus: true
            });
            this.props.handleFocus(e);
        };
        this.handleBlur = e => {
            const { required } = this.props;
            const { focusCounter } = this.state;
            window.clearTimeout(this.timer);
            this.timer = window.setTimeout(() => {
                this.setState({
                    hasFocus: false,
                    focusCounter: required ? focusCounter + 1 : 0
                });
                this.props.handleBlur(e);
            }, 50);
        };
        this.render = () => {
            const { classes, id, value, type, placeholder, handleChange, inputRef, prefix, suffix, status, disabled, errorMessage, required, dataCy } = this.props;
            const { focusCounter } = this.state;
            /**
             * the regex checks for a line with only white spaces.
             */
            const invalid = (value === '' || value.match(/^[ \t\r\n\s]*$/g)) &&
                focusCounter >= 0 &&
                required;
            const rootProps = {
                className: classes.root,
                'data-has-focus': this.state.hasFocus,
                'data-has-value': !!value.length,
                'data-is-invalid': status === status_1.STATUS_INVALID || (invalid === null ? false : invalid),
                'data-is-caution': status === status_1.STATUS_CAUTION,
                'data-is-valid': status === status_1.STATUS_VALID,
                'data-is-modified': status === status_1.STATUS_MODIFIED,
                'data-is-disabled': disabled,
                'data-is-required': required
            };
            const inputProps = {
                className: classes.input,
                id,
                value,
                type,
                placeholder,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                onChange: handleChange,
                ref: inputRef,
                disabled,
                'data-cy': dataCy,
                autoComplete: 'off'
            };
            return (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [jsx_runtime_1.jsxs("div", Object.assign({}, rootProps, { children: [prefix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.prefix }, { children: prefix }), void 0),
                            jsx_runtime_1.jsx("input", Object.assign({}, inputProps), void 0),
                            suffix && jsx_runtime_1.jsx(textinput_suffix_1.default, { children: suffix }, void 0)] }), void 0),
                    invalid && errorMessage && jsx_runtime_1.jsx(errorMessage_1.default, { text: errorMessage }, void 0)] }, void 0));
        };
    }
}
exports.Textinput = Textinput;
Textinput.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    id: prop_types_1.default.string,
    value: prop_types_1.default.string.isRequired,
    type: prop_types_1.default.oneOf(['text', 'password', 'search']).isRequired,
    placeholder: prop_types_1.default.string,
    handleFocus: prop_types_1.default.func,
    handleBlur: prop_types_1.default.func,
    handleChange: prop_types_1.default.func,
    inputRef: prop_types_1.default.oneOfType([
        prop_types_1.default.func,
        prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(Element) })
    ]),
    prefix: prop_types_1.default.node,
    suffix: prop_types_1.default.node,
    status: prop_types_1.default.oneOf([
        status_1.STATUS_INVALID,
        status_1.STATUS_CAUTION,
        status_1.STATUS_VALID,
        status_1.STATUS_MODIFIED
    ]),
    disabled: prop_types_1.default.bool,
    errorMessage: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    dataCy: prop_types_1.default.string
};
Textinput.defaultProps = {
    id: null,
    placeholder: null,
    handleFocus: () => { },
    handleBlur: () => { },
    handleChange: () => { },
    inputRef: () => { },
    prefix: null,
    suffix: null,
    status: null,
    disabled: false,
    errorMessage: '',
    required: false,
    dataCy: 'atomic-textinput'
};
exports.default = react_jss_1.default(textinput_style_1.default)(Textinput);
//# sourceMappingURL=textinput.js.map